export default "__VITE_ASSET__CA0bP0nd__"